import { Component } from '@angular/core';

@Component({
	selector: 'vg-scrub-bar-scrubber',
	template: `
		<div class="scrubber"></div>
	`,
	standalone: false,
	styleUrls: ['./VgScrubBarScrubber.Component.ng.less']
})
export class VgScrubBarScrubberComponent {
}
